export default __webpack_public_path__ + "static/media/slider-bubble-primary-03.f6beb8cb.svg";